<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="$_createActionAllowed"
            :title="'Vytvořit oznámení' | translate"
            route-name="messageNew"
        ></add-button>
        <h1 v-translate>Oznámení</h1>
      </div>
      <div class="inner_white">
        <div class="filter search_only">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>

        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="message-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"/>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.key"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <message-row v-for="entity in entities"
                             :entity="entity"
                             :key="entity.id"
                             @input="select"
                             @deleteMessage="deleteEntity"
                             :selectedEntities="selectedEntities"
                             @forward-message="forwardMessage"
                             @duplicate-recipients="duplicateRecipients"
                ></message-row>
                <tr v-if="entities.length === 0">
                     <td colspan="8">{{ $gettext('Nebyly nalezeny žádné oznámení.') }}</td>
                </tr>
              </table>
            </div>
          </div>
          <list-action-line
              :entities="entities"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              table-id="message-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="executeMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions"
import MessageRow from "./MessageRow"
import messages from "./mixins/messages"

export default {
  name: "MessageList",
  components: {
    MessageRow,
  },
  mixins: [listActions, messages],
  data: function () {
    return {
      moduleName: 'messages',
      formFields: {
        sort: {
          column: 'sDateUpdated',
          direction: 'desc',
        }
      },
    }
  },
  created(MessageService) {
    this.entityService = MessageService
    this.createdInit()
  },
  computed: {
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Datum odeslání'), column: 'sDateCreated'},
        {key: 3, name: this.$gettext('Počet příjemců'), column: 'sRecipientsCount'},
        {key: 4, name: this.$gettext('Globální oznámení'), column: 'sIdOperator'},
        {key: 5, name: this.$gettext('Typ oznámení'), column: 'sType'},
        {key: 6, name: this.$gettext('Odesilatel'), column: 'sOperatorName'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      headers.id_operator.callback = entity =>{ return entity.global ? this.$gettext('Ano'): this.$gettext('Ne')};
      headers.type.callback = entity => {
        let type = this.messageTypeOptions.find(o => o.value === entity.type);
        return (type && type.hasOwnProperty("text")) ? type.text : null;
      };

      return headers;
    },
  },
  methods: {
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.deleteEntity(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
    },
    forwardMessage(id){
      this.$router.push({name: 'messageNew', params: {forward_message: id}})
    },
    duplicateRecipients(id){
      this.$router.push({name: 'messageNew', params: {duplicate_recipients: id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/MessageList.vue